import { ServiceContent } from '@/base-api/types';

interface InfoModalInput {
  content: ServiceContent['info_modal'];
}

export const InfoModalInner = ({ content }: InfoModalInput) => {
  const {
    heading_image,
    heading,
    bullet_heading,
    bullet_1,
    bullet_2,
    bullet_3,
    terms_url,
    terms_label,
    icon_bullet_heading,
    icon_bullet_1_image,
    icon_bullet_1,
    icon_bullet_2_image,
    icon_bullet_2,
    icon_bullet_3_image,
    icon_bullet_3,
    icon_bullet_4_image,
    icon_bullet_4,
    background_image,
  } = content;

  const hasBullets = !!(
    (icon_bullet_1 && icon_bullet_1_image) ||
    (icon_bullet_2 && icon_bullet_2_image) ||
    (icon_bullet_3 && icon_bullet_3_image) ||
    (icon_bullet_4 && icon_bullet_4_image)
  );

  return (
    <div className="services-modal__content services-modal__content--info">
      <div className="services-modal__container">
        {heading_image && (
          <div className="services-modal__heading-image">
            <img src={heading_image} alt="Offer Heading Illustration" />
          </div>
        )}
        <div className="services-modal__info">
          {heading && <p className="services-modal__heading h4">{heading}</p>}
          {bullet_heading && (
            <span className="services-modal__bullet-heading">
              {bullet_heading}
            </span>
          )}
          {(bullet_1 || bullet_2 || bullet_3) && (
            <ul className="services-modal__bullets">
              {bullet_1 && <li>{bullet_1}</li>}
              {bullet_2 && <li>{bullet_2}</li>}
              {bullet_3 && <li>{bullet_3}</li>}
            </ul>
          )}

          {icon_bullet_heading && (
            <p className="services-modal__icon-heading">
              {icon_bullet_heading}
            </p>
          )}

          {hasBullets && (
            <div className="services-modal__icon-bullets">
              {icon_bullet_1 && icon_bullet_1_image && (
                <IconBullet
                  imageSrc={icon_bullet_1_image}
                  text={icon_bullet_1}
                  altText="First service benefit icon"
                />
              )}
              {icon_bullet_2 && icon_bullet_2_image && (
                <IconBullet
                  imageSrc={icon_bullet_2_image}
                  text={icon_bullet_2}
                  altText="Second service benefit icon"
                />
              )}
              {icon_bullet_3 && icon_bullet_3_image && (
                <IconBullet
                  imageSrc={icon_bullet_3_image}
                  text={icon_bullet_3}
                  altText="Second service benefit icon"
                />
              )}
              {icon_bullet_4 && icon_bullet_4_image && (
                <IconBullet
                  imageSrc={icon_bullet_4_image}
                  text={icon_bullet_4}
                  altText="Second service benefit icon"
                />
              )}
            </div>
          )}

          {terms_url && terms_label && (
            <p className="services-modal__terms">
              <a href={terms_url} target="_blank" rel="noopener noreferrer">
                {terms_label}
              </a>
            </p>
          )}
        </div>
      </div>
      <div className="services-modal__background-image">
        {background_image && (
          <img src={background_image} alt="Background Image" />
        )}
      </div>
    </div>
  );
};

interface IconBulletProps {
  imageSrc: string;
  text: string;
  altText: string;
}

const IconBullet = ({ imageSrc, text, altText }: IconBulletProps) => (
  <div className="services-modal__icon-bullet">
    <div className="services-modal__icon-bullet-image">
      <img src={imageSrc} alt={altText} />
    </div>
    <p className="services-modal__icon-bullet-text">{text}</p>
  </div>
);
